import React from "react";
import styled from "styled-components";

const Box = styled.div`
    position: absolute;
    right: 10px;
    bottom: 10px;
    z-index: 1000;
    background: #ffffffe3;
    border: 1px solid #d3d3d3;
    border-radius: 5px;
    padding: 8px 10px;
    font-size: 13px;
`;

const Line = styled.div`
    font-weight: bold;
    color: ${props => props.$color || "inherit"};
    white-space: nowrap;
`;

export const CourierStatsBox = ({stats}) => {
    const {total = 0, available = 0, unavailable = 0, onDelivery = 0, onBreak = 0} = stats || {};

    return (
        <Box>
            <Line>Toplam Kurye Sayısı: {total}</Line>
            <Line $color="green">Müsait Kurye Sayısı: {available}</Line>
            <Line $color="red">Meşgul Kurye Sayısı: {unavailable}</Line>
            <Line $color="orange">Siparişteki Kurye Sayısı: {onDelivery}</Line>
            <Line $color="#1890ff">Moladaki Kurye Sayısı: {onBreak}</Line>
        </Box>
    );
};
